import TicketsAPI from 'dashboard/api/tickets';

export const types = {
  SET_TICKETS: 'SET_TICKETS',
  SET_TICKET: 'SET_TICKET',
  SET_UI_FLAG: 'SET_TICKETS_UI_FLAG',
  SET_COUNTS: 'SET_TICKET_COUNTS',
};

export const state = {
  records: {},
  counts: {},
  uiFlags: {
    isFetching: false,
    isConverting: false,
  },
};

export const getters = {
  getTicket: _state => ticketNumber => _state.records[ticketNumber],
  getTicketByConversationId: _state => conversationId =>
    Object.values(_state.records).find(t => t.conversation?.id === conversationId),
  getCounts: _state => _state.counts,
  getUIFlags: _state => _state.uiFlags,
};

export const actions = {
  fetchTickets: async ({ commit }, params = {}) => {
    commit(types.SET_UI_FLAG, { isFetching: true });
    try {
      const { data } = await TicketsAPI.get(params);
      const list = data?.data?.payload || data?.payload || (Array.isArray(data) ? data : []);
      commit(types.SET_TICKETS, list);
      return list;
    } finally {
      commit(types.SET_UI_FLAG, { isFetching: false });
    }
  },
  fetchTicketByConversation: async ({ commit }, conversationId) => {
    try {
      const { data } = await TicketsAPI.showByConversation(conversationId);
      commit(types.SET_TICKET, data);
      return data;
    } catch (e) {
      if (e?.response?.status === 404) return null;
      throw e;
    }
  },
  fetchTicket: async ({ commit }, ticketNumber) => {
    const { data } = await TicketsAPI.show(ticketNumber);
    commit(types.SET_TICKET, data);
    return data;
  },
  convertConversation: async ({ commit }, { conversationId, payload }) => {
    commit(types.SET_UI_FLAG, { isConverting: true });
    try {
      const { data } = await TicketsAPI.convert(conversationId, payload);
      commit(types.SET_TICKET, data);
      return data;
    } finally {
      commit(types.SET_UI_FLAG, { isConverting: false });
    }
  },
  fetchCounts: async ({ commit }) => {
    const { data } = await TicketsAPI.counts();
    commit(types.SET_COUNTS, data.counts || data);
  },
  transition: async ({ commit }, { ticketNumber, payload }) => {
    const { data } = await TicketsAPI.transition(ticketNumber, payload);
    commit(types.SET_TICKET, data);
    return data;
  },
  update: async ({ commit }, { ticketNumber, payload }) => {
    const { data } = await TicketsAPI.update(ticketNumber, payload);
    commit(types.SET_TICKET, data);
    return data;
  },
};

export const mutations = {
  [types.SET_TICKET](_state, ticket) {
    if (ticket?.ticket_number) {
      _state.records = { ..._state.records, [ticket.ticket_number]: ticket };
    }
  },
  [types.SET_TICKETS](_state, tickets) {
    const records = {};
    tickets.forEach(t => {
      records[t.ticket_number] = t;
    });
    _state.records = records;
  },
  [types.SET_UI_FLAG](_state, flags) {
    _state.uiFlags = { ..._state.uiFlags, ...flags };
  },
  [types.SET_COUNTS](_state, counts) {
    _state.counts = counts;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
